import { useEffect, useState } from "react";
import api from "@/lib/api";
import { EnvelopeSimpleOpen } from "@phosphor-icons/react";

export default function EmbedCounter() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const load = () => api.get("/public/counter").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen bg-foreground text-background flex items-center justify-center p-8">
      <div className="border border-background/30 p-10 max-w-2xl w-full">
        <div className="flex items-center gap-2 mb-6">
          <img src="/easy-mail-logo.png" alt="Easy Mail" className="h-7 w-auto" />
          <span className="font-display font-bold tracking-tight">Easy Mail — LIVE</span>
        </div>
        <div className="font-mono text-6xl sm:text-7xl font-bold mb-2" data-testid="counter-deleted">
          {data ? data.total_deleted.toLocaleString() : "—"}
        </div>
        <div className="text-sm uppercase tracking-widest opacity-70 mb-8">Emails deleted worldwide</div>
        <div className="grid grid-cols-2 gap-px bg-background/30">
          <div className="bg-foreground p-4">
            <div className="text-xs uppercase tracking-widest opacity-70 mb-1">Time saved</div>
            <div className="font-mono text-2xl font-bold">{data ? `${data.time_saved_minutes.toLocaleString()} min` : "—"}</div>
          </div>
          <div className="bg-foreground p-4">
            <div className="text-xs uppercase tracking-widest opacity-70 mb-1">Inbox warriors</div>
            <div className="font-mono text-2xl font-bold">{data ? data.users.toLocaleString() : "—"}</div>
          </div>
        </div>
        <div className="mt-8 text-xs font-mono uppercase tracking-widest opacity-60">
          Updated every 10s · easymail.app
        </div>
      </div>
    </div>
  );
}
